<template>
  <div class="app-container">
    <el-tabs v-model="active" @tab-click="handleClick" type="card" class="cardTabs">
      <el-tab-pane label="综合评价指标" name="0"></el-tab-pane>
      <el-tab-pane label="学业影响力排行" name="1"></el-tab-pane>
    </el-tabs>
    <list ref="list" v-show="active==0" @listdata="listdata">
      <template slot="toolbar-right" v-if="!isMB">
        <el-button size="small" class="filter-item" @click="onExport('list')" type="primary" plain>导出</el-button>
      </template>
    </list>
    <list2 ref="list2" v-show="active==1">
      <template slot="toolbar-right" v-if="!isMB">
        <el-button size="small" class="filter-item" @click="onExport('list2')" type="primary" plain>导出</el-button>
      </template>
    </list2>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/analyse/teacher/list";
import list2 from "@/components/analyse/teacher/list2";

export default {
  name: "teacher",
  mixins: [curdMixins],
  components: {
    list,
    list2,
  },
  data() {
    return {
      active: "0",
      last: -1,
      isMB: this.$store.state.isMB,
      setData: {},
    }
  },
  methods: {
    reload() {
      // this.handleClick(this.active);
    },
    listdata(data) {
      this.setData = data;
    },
    onExport(name) {
      this.$refs[name].export();
    },
    handleClick(e) {
      if(this.active == this.last) {
        return
      } else {
        this.last = this.active;
      }
      setTimeout(() => {
        if(this.active=='0') {
          // this.$refs.list.getData();
        } else if(this.active=='1') {
          this.$refs.list2.setData(this.setData);
          // this.$refs.list2.getData();
        }
      }, 200);
    },
  },
};
</script>